import TreeSelect from './tree-select';
export * from './tree-select';
export default TreeSelect;